import { SET_LIST_PERIOD } from './periodConst';

export function setListPeriod(period) {
  return {
    type: SET_LIST_PERIOD,
    period
  };
}
